import {FC, useMemo} from 'react'
import {
  buildTrendSeriesColorMap,
  getTrendSeriesKey,
  isMultiSeriesBreakout,
  ShipmentTrendBreakout,
} from '../helpers/organizationAnalyticsHelpers'
import {ShipmentTrendSeries} from '../core/_types'
import {OVERALL_SERIES_COLOR, TREND_SERIES_COLORS} from '../core/_const'

type Props = {
  activeView: ShipmentTrendBreakout
  seriesTrendData: ShipmentTrendSeries[]
  shipmentsLabel: string
}

const ShipmentTrendsLegend: FC<Props> = ({activeView, seriesTrendData, shipmentsLabel}) => {
  const colorMap = useMemo(() => buildTrendSeriesColorMap(seriesTrendData), [seriesTrendData])

  if (isMultiSeriesBreakout(activeView) && seriesTrendData.length > 0) {
    return (
      <div className='shipment-trends__legend shipment-trends__legend--multi'>
        {seriesTrendData.map((series, index) => (
          <div
            key={`${activeView}-${getTrendSeriesKey(series)}-${index}`}
            className='shipment-trends__legend-item'
          >
            <span
              className='shipment-trends__legend-swatch'
              style={{
                background:
                  colorMap[getTrendSeriesKey(series)] ??
                  TREND_SERIES_COLORS[index % TREND_SERIES_COLORS.length],
              }}
            />
            <span className='shipment-trends__legend-label'>{series.label}</span>
          </div>
        ))}
      </div>
    )
  } else if (activeView === 'overall') {
    return (
      <div className='shipment-trends__legend'>
        <span className='shipment-trends__legend-dot' style={{background: OVERALL_SERIES_COLOR}} />
        <span className='shipment-trends__legend-label'>{shipmentsLabel}</span>
      </div>
    )
  }

  return null
}

export {ShipmentTrendsLegend}
